<template>
  <div>
    <ProfileName class="ma-0 text-center profileName" :profileName="profileName" />
    <ProfileEmail class="ma-0 text-center profileEmail" :profileEmail="profileEmail" />
  </div>
</template>

<script>
import ProfileName from "@/components/atoms/profile-name";
import ProfileEmail from "@/components/atoms/profile-email";

export default {
  components: { ProfileName, ProfileEmail },
  props: {
    profileName: {
      type: String,
      required: true
    },
    profileEmail: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.profileName {
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #000;
}

.profileEmail {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #9e9e9e;
}
</style>
